'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dPartial$002dFunction$0024 from "./scala.-Partial-Function$.js";
var $p;
/** @constructor */
function $c_s_PartialFunction$Lifted(pf) {
  this.Mu = null;
  this.Mu = pf;
}
export { $c_s_PartialFunction$Lifted as $c_s_PartialFunction$Lifted };
$p = $c_s_PartialFunction$Lifted.prototype = new $j_java$002elang$002e$002dObject.$h_sr_AbstractFunction1();
$p.constructor = $c_s_PartialFunction$Lifted;
/** @constructor */
function $h_s_PartialFunction$Lifted() {
}
export { $h_s_PartialFunction$Lifted as $h_s_PartialFunction$Lifted };
$h_s_PartialFunction$Lifted.prototype = $p;
$p.B9 = (function(x) {
  var z = this.Mu.cr(x, $j_scala$002e$002dPartial$002dFunction$0024.$m_s_PartialFunction$().ws);
  return ((!$j_scala$002e$002dPartial$002dFunction$0024.$m_s_PartialFunction$().Xi(z)) ? new $j_java$002elang$002e$002dObject.$c_s_Some(z) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.j = (function(v1) {
  return this.B9(v1);
});
var $d_s_PartialFunction$Lifted = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_PartialFunction$Lifted, "scala.PartialFunction$Lifted", ({
  rE: 1,
  cF: 1,
  o: 1,
  a: 1
}));
export { $d_s_PartialFunction$Lifted as $d_s_PartialFunction$Lifted };
